import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Define breadcrumb data array
const breadcrumbData = [
  {
    title: 'Home',
    path: '/',
    image: './assets/img/breadcrumb/home.jpg',
  },
  {
    title: 'Contact Us',
    path: '/contact-us',
    image: './assets/img/breadcrumb/contact-us.jpg',
  },
  {
    title: 'Tours',
    path: '/tours',
    image: './assets/img/breadcrumb/tours.jpg',
  },
  {
    title: 'Tour Details',
    path: '/tour-details/:id',
    image: './assets/img/breadcrumb/tour-details.jpg',
    parent: '/tours', // Nested under Tours
  },
  {
    title: 'About Us',
    path: '/about',
    image: './assets/img/breadcrumb/about.jpg',
  },
  {
    title: 'Blog',
    path: '/blog',
    image: './assets/img/breadcrumb/blog.jpg',
  },
];

function BreadcrumbSection() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Find the current page in breadcrumbData
  const currentPage = breadcrumbData.find((page) =>
    page.path === currentPath ||
    (page.path.includes(':id') && currentPath.match(/^\/tour-details\/\d+$/))
  ) || breadcrumbData[0]; // Fallback to Home

  // Build breadcrumb trail
  const getBreadcrumbTrail = (page) => {
    const trail = [{ title: page.title, path: page.path }];
    if (page.parent) {
      const parentPage = breadcrumbData.find((p) => p.path === page.parent);
      if (parentPage) {
        trail.unshift(...getBreadcrumbTrail(parentPage));
      }
    }
    return trail;
  };

  const breadcrumbTrail = getBreadcrumbTrail(currentPage);

  return (
    <section
      className="breadcrumb-wrapper fix bg-cover"
      style={{ backgroundImage: `url(${currentPage.image})` }}
    >
      <div className="container">
        <div className="row">
          <div className="page-heading">
            <h2>{currentPage.title}</h2>
            <ul className="breadcrumb-list">
              {breadcrumbTrail.map((item, index) => (
                <React.Fragment key={item.path}>
                  <li className={index === breadcrumbTrail.length - 1 ? 'active' : ''}>
                    {index === breadcrumbTrail.length - 1 ? (
                      item.title
                    ) : (
                      <Link to={item.path}>{item.title}</Link>
                    )}
                  </li>
                  {index < breadcrumbTrail.length - 1 && (
                    <li>
                      <i className="fa-solid fa-chevrons-right"></i>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BreadcrumbSection;